export class GenericReportResponse {

  constructor(public result: string, public error: string, public data: any) {
  }
}
